var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAllocationIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_52180_28312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 1.85938V3.85938C7 4.12459 7.10536 4.37895 7.29289 4.56648C7.48043 4.75402 7.73478 4.85938 8 4.85938H10",
    stroke: "#8496A9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 4.35938V2.85938C2 2.59416 2.10536 2.3398 2.29289 2.15227C2.48043 1.96473 2.73478 1.85938 3 1.85938",
    stroke: "#8496A9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.03125 11.3589C2.12918 11.5323 2.27668 11.6726 2.45485 11.7617C2.63301 11.8508 2.83372 11.8846 3.03125 11.8589L8.99975 11.8594C9.26497 11.8594 9.51932 11.754 9.70686 11.5665C9.89439 11.3789 9.99975 11.1246 9.99975 10.8594V4.35938L7.49975 1.85938H2.99975",
    stroke: "#8496A9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 6.35938L6 7.85938",
    stroke: "#8496A9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9.35938L6 7.85938H1",
    stroke: "#8496A9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_52180_28312"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 0.859375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllocationIcon);
export default __webpack_public_path__ + "static/media/allocationIcon.4bd3a3c05d883ef934e0591ba0926383.svg";
export { ForwardRef as ReactComponent };